import FreefieldInput from "components/Freefields/Inputs/FreefieldInput";
import ReadonlyFreefieldValue from "components/Freefields/Readonly/ReadonlyFreefieldValue";
import { type FreefieldCategoryWithValuesAndPermissions, type FreefieldDefinitionWithValueAndPermission, type FreefieldState } from "components/Freefields/models";
import LabelledDivRow from "components/LabelledDivRow";
import React from "react";

interface Props {
  freefieldCategoryWithValueAndPermission: FreefieldCategoryWithValuesAndPermissions
  freefieldState: FreefieldState
}

const FreefieldPanel = ({ freefieldState, freefieldCategoryWithValueAndPermission }: Props) => {
  const canSeeReadonlyFreefield = (ff: FreefieldDefinitionWithValueAndPermission) =>
    // We show the ff if it has a value that we can display. Otherwise we hide it
    ff.displayValue.hasVisibleValue && ff.permission === "view";

  return <>
    {freefieldCategoryWithValueAndPermission
      .definitionWithValues
      .filter(def => def.permission === "viewModify" || canSeeReadonlyFreefield(def))
      .map(def =>
        <LabelledDivRow key={def.reference} label={def.title} sublabel={def.description} title={`${RESX.FreeField.ReferenceCode}: ${def.reference}`}>
          {def.permission === "viewModify" && <FreefieldInput
            type={def.type}
            initialValue={def.displayValue.value}
            onChange={value => { freefieldState.setEditableFreefieldValue(def.freeFieldDefinitionId, value); }}
            dropdownOptions={def.dropdownOptions}
            validatorKey={`freefieldId:${def.freeFieldDefinitionId}`}
            reference={def.reference}
          />}
          {def.permission === "view" && <ReadonlyFreefieldValue
            type={def.type}
            displayValue={def.displayValue}
          />}
        </LabelledDivRow>
      )}
  </>;
};

export default FreefieldPanel;